import { render, staticRenderFns } from "./OpeningHoursModal.vue?vue&type=template&id=bb044566&scoped=true&"
import script from "./OpeningHoursModal.vue?vue&type=script&lang=js&"
export * from "./OpeningHoursModal.vue?vue&type=script&lang=js&"
import style0 from "./OpeningHoursModal.vue?vue&type=style&index=0&id=bb044566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb044566",
  null
  
)

export default component.exports